/**
 * Throw custom error
 * @param message
 */
const throwError = (message) => { throw new Error(message); };

export default throwError;
